import axiosService from './axiosService';

class DocumentService {
  searchDocuments = (data) => axiosService.post('/api/documents/search', data);

  exportDocuments = (data) => axiosService.postBlob('/api/documents/export', data);

  exportSelectedDocuments = (data) => axiosService.postBlob('/api/documents/export/selected', data);

  getDocumentDetails = (docId) => axiosService.get(`/api/documents/${docId}`);

  deleteDocument = (docId) => axiosService.delete(`/api/documents/${docId}`);

  deleteDocuments = (docIdArray) => axiosService.post('/api/documents/delete', docIdArray);

  restoreDocument = (docId) => axiosService.post(`/api/documents/restore/${docId}`);

  restoreDocuments = (docIdArray) => axiosService.post('/api/documents/restore', docIdArray);

  getDocumentContent = (docId, pwd) => {
    const data = {
      docId,
      Password: pwd
    };

    return axiosService.postBlob('/api/documents/content', data);
  }

  getDocumentFile = (docId) => axiosService.getBlob(`/api/documents/view/${docId}`);

  getDocumentsZip = (docIdArray) => axiosService.postBlob('/api/documents/zip', docIdArray);

  getDocumentsPdf = (docIdArray, pwd) => {
    const data = {
      DocIds: docIdArray,
      Password: pwd
    };

    return axiosService.postBlob('/api/documents/pdf', data);
  }

  modifyDocument = (data, docId, numberPages) => {
    const base64 = btoa(
      new Uint8Array(data.blob)
        .reduce((data2, byte) => data2 + String.fromCharCode(byte), '')
    );

    const dataw = {
      Document: base64,
      DocID: docId,
      NumberPages: numberPages
    };
    return axiosService.post('/api/documents/modify/', dataw);
  };

  splitDocument = (blob1, docId, editFields1, blob2, editFields2, numberPages1, numberPages2) => {
    const base641 = btoa(
      new Uint8Array(blob1)
        .reduce((data2, byte) => data2 + String.fromCharCode(byte), '')
    );

    const base642 = btoa(
      new Uint8Array(blob2)
        .reduce((data3, byte) => data3 + String.fromCharCode(byte), '')
    );

    const dataw = {
      DocumentFirst: base641,
      DocID: docId,
      EditFieldsFirst: editFields1,
      DocumentSecond: base642,
      EditFieldsSecond: editFields2,
      NumberPagesFirst: numberPages1,
      NumberPagesSecond: numberPages2
    };
    return axiosService.post('/api/documents/split', dataw);
  };

  uploadDocuments = (data) => {
    const bodyFormData = new FormData();
    bodyFormData.append('Repository', data.repository);
    bodyFormData.append('Files', data.files);
    data.fields.forEach((field) => bodyFormData.append([field.name], field.value));
    return axiosService.postFormData('/api/documents', bodyFormData);
  };

  updateDocument = (data, docId) => axiosService.put(`/api/documents/${docId}`, { docId, editFields: data });

  emailDocuments = (data) => axiosService.post('/api/documents/email', data);
}

const documentService = new DocumentService();
export default documentService;
